import { CLIENTS } from "@/data/cybernet";

export const Testimonials = () => {
  const doubled = [...CLIENTS, ...CLIENTS];

  return (
    <section
      data-testid="testimonials-section"
      className="bg-[#0A0A0A] text-white py-16 md:py-24 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600] mb-4">
              — Clientes que confían en nosotros
            </div>
            <h2 className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-white max-w-2xl">
              Instituciones y empresas que ya son parte de nuestra historia.
            </h2>
          </div>
        </div>
      </div>

      <div className="relative">
        <div
          className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(to right, #0A0A0A, rgba(10,10,10,0))",
          }}
        />
        <div
          className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(to left, #0A0A0A, rgba(10,10,10,0))",
          }}
        />
        <div className="flex animate-marquee gap-4 w-max">
          {doubled.map((c, i) => (
            <div
              key={i}
              className="shrink-0 border border-white/10 px-8 py-6 min-w-[280px] hover:border-[#E10600] transition-colors"
            >
              <div className="text-xs uppercase tracking-widest text-[#E10600] mb-2">
                Cliente
              </div>
              <div className="font-display font-bold text-lg text-white leading-tight">
                {c}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-14">
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border-l-2 border-[#E10600] pl-6">
            <div className="font-display font-black text-4xl text-white mb-2">
              20+
            </div>
            <p className="text-sm text-white/70">años atendiendo Cortazar</p>
          </div>
          <div className="border-l-2 border-[#E10600] pl-6">
            <div className="font-display font-black text-4xl text-white mb-2">
              4
            </div>
            <p className="text-sm text-white/70">sucursales activas</p>
          </div>
          <div className="border-l-2 border-[#E10600] pl-6">
            <div className="font-display font-black text-4xl text-white mb-2">
              100%
            </div>
            <p className="text-sm text-white/70">
              atención personalizada y responsable
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
